module.exports = "/_next/static/images/homealt-a682f055b0104749e93a23f8b228163f.svg";